import React from "react";
import Img from "../../Assets/Images/ContactUs/location.png";
import N1Img from "../../Assets/Images/ContactUs/n1.png";
import N2Img from "../../Assets/Images/ContactUs/n2.png";

import S1Img from "../../Assets/Images/ContactUs/s1.png";
import S2Img from "../../Assets/Images/ContactUs/s2.png";
import S3Img from "../../Assets/Images/ContactUs/s3.png";
import "./contactus.css";
import ContactUsBlock from "../../Components/ContactUsBlock/ContactUsBlock";
import Sponsors from "../../Components/Home/Sponsers/Sponsers";
import StaticPageHeaders from "../../Components/StaticPageHeaders";
import ContactForm from "../../Components/ContactForm/ContactForm";
import SEO from "../../Components/SEO";

const north = [
  {
    image: N2Img,
    description: "Holy Family (366 Watchogue Rd, Staten Island, NY 10314)",
  },
  {
    image: N1Img,
    description: "St. Rita's (281 Bradley Ave, Staten Island, NY 10314)",
  },
];

const south = [
  {
    image: S1Img,
    description: "I.S. 34 (528 Academy Ave, Staten Island, NY 10307)",
  },
  {
    image: S2Img,
    description: "JumpShotz (120 Androvette St, Staten Island, NY 10309)",
  },
  {
    image: S3Img,
    description: "St Patrick's (3560 Richmond Rd, Staten Island, NY 10306)",
  },
];

const ContactUs = () => {
  return (
    <>
      <SEO
        title="Contact - Shootin School Basketball"
        description=""
        url="https://shootinschool.com/contact/"
      />
      <StaticPageHeaders title="Contact Us" />

      <div className="contactus-container">
        <div className="contactus-sss-layout bg-custom brightness">
          <div className="sss-flex">
            <ContactForm />
          </div>

          <div className="contactus-sss-layout-header">
            <span className="text-clip">
              We Operate out of Multiple Gym Locations on
            </span>
            <span className="second-heading text-clip">
              The North & South Shore Of Staten Island, NY
            </span>
          </div>

          <div className="contactus-sss-layout-header-location">
            <span className="second-heading-location text-clip">
              North Shore:
            </span>
          </div>

          <div className="sss-grid">
            {north.map((successstory, i) => (
              <ContactUsBlock
                key={i}
                image={successstory.image}
                description={successstory.description}
              />
            ))}
          </div>

          <div className="contactus-sss-layout-header-location">
            <span className="second-heading-location text-clip">
              South Shore:
            </span>
          </div>

          <div className="sss-grid">
            {south.map((successstory, i) => (
              <ContactUsBlock
                key={i}
                image={successstory.image}
                description={successstory.description}
              />
            ))}
          </div>

          <div
            className="sss-flex"
            style={{ marginTop: "40px", borderRadius: "40px" }}
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d96990.69716448577!2d-74.2292195487149!3d40.56457632769734!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c245ef79f4d4e7%3A0x50271f8534babc78!2sStaten%20Island%2C%20NY%2C%20USA!5e0!3m2!1sen!2sin!4v1764168355902!5m2!1sen!2sin"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
              style={{ width: "100%", height: "400px", borderRadius: "20px", filter: "brightness(0.8)" }}
            ></iframe>
          </div>
        </div>
      </div>

      <div className="about-contactus sss-sp">
        <Sponsors />
      </div>
    </>
  );
};
export default ContactUs;
